export const DEFAULT_MAX_TERM = 30;